import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import { ReactComponent as DownloadIcn } from "Assets/Images/icn/download.svg";
import { ReactComponent as InfoIcn } from "Assets/Images/icn/infoI.svg";
import { ReactComponent as EditIcn } from "Assets/Images/icn/Edit.svg";
import { getRecommendationReport } from "store/services/clientDataReportsService";
import { useParams } from "react-router-dom";
import { decode } from "html-entities";
import { addClientRecommendation, downloadToDoRecommReport, getClientRecommendationList, getClientRecommendationReportsList, prepopulateRecommFromNAQ } from "store/services/clientService";
import { connect } from "react-redux";
import * as actions from "store/actions";
import { SUCCESS_MESSAGE } from "common/constantMessage";
import DownloadNAQRecommPDF from "components/shared/PDFComponents/Recommendations/NAQRecommReportPDF";
import NewRecommSuccessPopup from "../../Modal/NewRecommSuccessPopup";
import { NAQV2_ID, PERMISSION_CONSTANTS } from "common/constants";
import useInstancePermissions from "hooks/useInstancePermissions";
import moment from "moment";

const RecommendationReport = ({ dispatch, todo, getDetails, client, handleEditRecommendation }) => {
  const { clientId } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [recommendationData, setRecommendationData] = useState(null);
  // const [nutritionalInformation, setNutritionalInformation] = useState(null);
  const [products, setProducts] = useState(null);
  const [selectedManufacturer, setSelectedManufacturer] = useState("generic");
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [newRecommendationId, setNewRecommendationId] = useState(null);

  const isAllowedToViewSection = useInstancePermissions();

  useEffect(() => {
    if (isOpen && !recommendationData) {
      getRecommendationReportData();
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedManufacturer && recommendationData) {
      const filteredProducts = recommendationData[selectedManufacturer] || [];
      setProducts(filteredProducts);
    }
  }, [selectedManufacturer, recommendationData])

  const getRecommendationReportData = async () => {
    try {
      if (!todo.todo_id) {
        throw new Error("Invalid ToDo ID");
      }
      setIsLoading(true);
      const response = await getDetails(todo.todo_id);
      if (response.success === true) {
        const data = response.body;
        setRecommendationData(data);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  }

  const createRecommendation = async () => {
    try {
      let clientId = client.id;
      const data = {
        recommendation: {
          nutritional: [],
          lifestyle: [],
        },
        additional_recommendation: {},
        // client_goals: "test",
        visit_number: "1",
        recommendation_type: "nutritional",
      };

      if (recommendationData && recommendationData[selectedManufacturer]) {
        let rows = recommendationData[selectedManufacturer].map(row => {
          return {
            recommendation: row.productName,
            benefit: row.instructions,
            per_day: null,
            upon_waking: row.dosageUponRising,
            with_breakfast: row.dosageBreakfast,
            midmorning: row.dosageMidMorning,
            with_lunch: row.dosageLunch,
            midafternoon: row.dosageMidAfternoon,
            with_dinner: row.dosageDinner,
            before_bed: row.dosageBeforeBed,
          }
        });
        data.recommendation.nutritional = rows;
        data.recommendation = data.recommendation;
      }

      if (data) {
        let postData = {
          ...data,
          client_id: client?.id,
          recommendation: JSON.stringify(data.recommendation),
          additional_recommendation: JSON.stringify(data.additional_recommendation),
        }

        const callback = (response) => {
          let { body } = response;
          if (response.success === true && body.id) {
            setNewRecommendationId(body.id);
            setShowSuccessPopup(true);
          }
        }
        setButtonDisabled(true);
        dispatch(actions.persist_store({ loader: true }));

        let response = await prepopulateRecommFromNAQ(postData, callback);
        if (response?.success === true && response?.body.todo_id) {
          setNewRecommendationId(response?.body.todo_id);
          setShowSuccessPopup(true);
        }
        await dispatch(getClientRecommendationReportsList({ clientId }));

        dispatch(actions.persist_store({ loader: false }));
        setButtonDisabled(false);
      }
    } catch (error) {
      console.log("Error creating recommendation", error);
      dispatch(actions.persist_store({ loader: false }));
      setButtonDisabled(false);
    }
  }

  const downloadReport = async () => {
    try {
      dispatch(actions.persist_store({ loader: true }));
      let response = await downloadToDoRecommReport(todo.todo_id);
      console.log(response)
      var base64String = response.body;

      const downloadLink = document.createElement("a");

      downloadLink.href = "data:application/pdf;base64, " + base64String;

      downloadLink.download = "Recommendation.pdf";

      downloadLink.click();
      // if (response.success === true && response.body) {
      //   setRecommendationDetails(response.body);
      // }
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log("Error occurred while downloading report", err);
      dispatch(actions.persist_store({ loader: false }));
    }
  }

  if (!todo) {
    return "";
  }

  return (
    <Accordion.Item eventKey={todo.todo_id} className="recommendation-report  my-2">
      <Accordion.Header
        className="accordian-cap"
        style={{
          background: "#FFFDFA",
          border: "1px solid #405C40",
          color: "#405C40",
          textTransform: "capitalize"
        }}
      >
        ({todo.form_id === NAQV2_ID ? "NAQ v2" : "NAQ"}) Recommendations Report
        <span className="toggleBtn position-absolute"></span>
        <div className="right d-flex align-items-center gap-10">
          <p className="m-0 text-dark text-lowercase fw-sbold">
            {`from ${moment(todo?.completed_at).format("MMM DD, YYYY")}`}
          </p>
        </div>
      </Accordion.Header>
      <Accordion.Body
        onEnter={() => {
          setIsOpen(true)
        }}
        onExit={() => {
          setIsOpen(false)
        }}
      >
        <NewRecommSuccessPopup
          showPopup={showSuccessPopup}
          handleClose={() => {
            setShowSuccessPopup(false);
          }}
          viewRecommendation={() => {
            console.log("handleEditRecommendation", newRecommendationId);
            handleEditRecommendation(newRecommendationId);
          }}
        />
        {isLoading ?
          <p>Loading...</p>
          :
          <div className="accordion-inner">
            <div className="py-2">
              <div className="top d-flex align-items-center justify-content-between gap-10">
                <div className="left">
                  <p className="m-0">
                    The following supplements are based on the potential conditions
                    and nutritional deficiencies shown in the Symptom Burden Report.
                  </p>
                </div>
                <div className="right d-flex gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn btnSm"
                    onClick={createRecommendation}
                    disabled={isButtonDisabled}
                  >
                    <span className="icn me-2">
                      <EditIcn />
                    </span>
                    Prepopulate/Edit in Recommendation Form
                  </Button>
                  {/* <Button
                    onClick={downloadReport}
                    className="d-flex align-items-center justify-content-center commonBtn btnSm"
                  >
                    <span className="icn me-2">
                      <DownloadIcn />
                    </span>
                    Download Report
                  </Button> */}
                  {recommendationData &&
                    <DownloadNAQRecommPDF
                      nutritionalRows={products}
                      details={recommendationData}
                      client={client}
                      manufacturer={selectedManufacturer}
                      date={todo?.completed_at}
                    />
                  }
                </div>
              </div>
            </div>
            <div className="py-2">
              <div className="top d-flex align-items-center justify-content-between gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <p className="m-0 capitalize fw-bold">Supplement Brand :</p>
                  <Form.Select
                    className="form-control fw-sbold btnSm"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setSelectedManufacturer(e.target.value);
                    }}
                  >
                    <option value="generic">Generic</option>
                    <option value="biotics">Biotics</option>
                    {isAllowedToViewSection(PERMISSION_CONSTANTS.SHOW_WISE_WOMAN_PRODUCTS) && (
                      <option value="wise_woman">Wise Woman Herbals</option>
                    )}
                  </Form.Select>
                </div>
              </div>
            </div>
            <div className="py-2">
              <div className="commonCardBox">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      {" "}
                      <tr>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          Product
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          Upon Rising
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          With Breakfast
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          Mid Morning
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          With Lunch
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          Mid Afternoon
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          With Dinner
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          Before Bed
                        </th>
                        <th className="p-3 fw-normal text-dark fw-sbold">
                          Instructions / Notes
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {products && products.length > 0 ?
                        products.map((product) => {
                          return (
                            <tr>
                              <td className="p-3 border-0">
                                <b>
                                  {decode(product.productName)}
                                </b>
                              </td>
                              <td className="p-3 border-0">{product.dosageUponRising}</td>
                              <td className="p-3 border-0">{product.dosageBreakfast}</td>
                              <td className="p-3 border-0">{product.dosageMidMorning}</td>
                              <td className="p-3 border-0">{product.dosageLunch}</td>
                              <td className="p-3 border-0">{product.dosageMidAfternoon}</td>
                              <td className="p-3 border-0">{product.dosageDinner}</td>
                              <td className="p-3 border-0">{product.dosageBeforeBed}</td>
                              <td className="p-3 border-0">
                                <b>
                                  {product.instructions}
                                </b>
                                <p className="m-0 py-1">
                                  Conditions/Deficiencies: {product?.conditionNames} *
                                </p>
                              </td>
                            </tr>
                          )
                        })
                        :
                        <tr>
                          <td colSpan={11} className="p-3 border-0">Data not available</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="py-2">
              <div
                className="Note px-3 py-2 commonCardBox d-flex align-items-start"
                style={{ background: "rgb(245, 245, 245)" }}
              >
                <div className="imgWrp me-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_0_5147)">
                      <path
                        d="M8.34343 0.15332C4.20184 0.15332 0.84375 3.51142 0.84375 7.653C0.84375 11.7946 4.20184 15.1533 8.34343 15.1533C12.485 15.1533 15.8437 11.7946 15.8437 7.653C15.8437 3.51142 12.485 0.15332 8.34343 0.15332ZM9.9047 11.7768C9.51867 11.9292 9.21137 12.0447 8.98089 12.1247C8.72237 12.2092 8.45154 12.2497 8.17962 12.2447C7.71232 12.2447 7.34851 12.1305 7.08946 11.9025C6.83042 11.6746 6.70153 11.3857 6.70153 11.0346C6.70153 10.8981 6.71105 10.7584 6.7301 10.6162C6.75364 10.4542 6.78479 10.2934 6.82343 10.1343L7.30661 8.4276C7.34915 8.26379 7.38597 8.10824 7.41518 7.96348C7.44438 7.81745 7.45835 7.68348 7.45835 7.56157C7.45835 7.34443 7.41327 7.19205 7.32375 7.10634C7.23296 7.02062 7.06216 6.97872 6.80756 6.97872C6.68311 6.97872 6.55486 6.99713 6.42343 7.03586C6.29327 7.07586 6.18026 7.11205 6.08756 7.1476L6.21518 6.62189C6.53137 6.493 6.83423 6.38253 7.12311 6.2911C7.38729 6.20271 7.66362 6.15602 7.94216 6.15268C8.40629 6.15268 8.76438 6.2657 9.01645 6.48919C9.26724 6.71332 9.39359 7.00475 9.39359 7.36284C9.39359 7.43713 9.3847 7.56792 9.36756 7.75459C9.35266 7.92902 9.32033 8.10152 9.27105 8.26951L8.79042 9.9711C8.74734 10.125 8.71195 10.281 8.68438 10.4384C8.65821 10.5694 8.64271 10.7023 8.63803 10.8359C8.63803 11.0619 8.68819 11.2162 8.78978 11.2981C8.8901 11.38 9.06597 11.4213 9.31486 11.4213C9.43232 11.4213 9.56375 11.4003 9.71232 11.3597C9.85962 11.319 9.96629 11.2828 10.0336 11.2517L9.9047 11.7768ZM9.81962 4.87014C9.60108 5.07623 9.31043 5.18839 9.0101 5.18253C8.69518 5.18253 8.42343 5.0784 8.1974 4.87014C8.08991 4.77559 8.00405 4.659 7.94565 4.52829C7.88725 4.39759 7.8577 4.25584 7.85899 4.11268C7.85899 3.81745 7.97327 3.56348 8.1974 3.35332C8.41641 3.14559 8.70829 3.03226 9.0101 3.03776C9.32565 3.03776 9.59613 3.14253 9.81962 3.35332C10.0437 3.56348 10.1561 3.81745 10.1561 4.11268C10.1561 4.40919 10.0437 4.66189 9.81962 4.87014Z"
                        fill="#030104"
                      ></path>
                    </g>
                    <defs>
                      <clipPath id="clip0_0_5147">
                        <rect
                          width="15"
                          height="15"
                          fill="white"
                          transform="translate(0.84375 0.15332)"
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="content">
                  <p className="m-0 text-muted">
                    <i>
                      *Statements made on this site and reference materials have not
                      been evaluated by the Food and Drug Administration. These
                      products or protocols may be helpful in correcting the
                      imbalances associated with the potential
                      conditions/deficiencies related to your client's symptoms.
                      These products or protocols are not intended to diagnose,
                      treat, cure or prevent any disease or be used as a substitute
                      for appropriate care of a qualified health practitioner.
                    </i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
      </Accordion.Body>
    </Accordion.Item>
  )

  return (
    <>
      <div className="recommendation-report">
        <h4>Recommendation Report</h4>
        <div className="py-2">
          <div className="top d-flex align-items-center justify-content-between gap-10">
            <div className="left">
              <p className="m-0">
                The following supplements are based on the potential conditions
                and nutritional deficiencies shown in the Symptom Burden Report.
              </p>
            </div>
            <div className="right">
              <Button className="d-flex align-items-center justify-content-center commonBtn btnSm">
                <span className="icn me-2">
                  <DownloadIcn />
                </span>
                Download Report
              </Button>
            </div>
          </div>
        </div>
        <div className="py-2">
          <div className="top d-flex align-items-center justify-content-between gap-10">
            <div className="left d-flex align-items-center gap-10">
              <p className="m-0 capitalize fw-bold">Supplement Brand :</p>
              <Form.Select
                className="form-control fw-sbold btnSm"
                aria-label="Default select example"
                onChange={(e) => {
                  setSelectedManufacturer(e.target.value);
                }}
              >
                <option value="1">Generic</option>
                <option value="2">Biotics</option>
                <option value="3">Wise Woman Herbals</option>
              </Form.Select>
            </div>
          </div>
        </div>
        <div className="py-2">
          <div className="commonCardBox">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  {" "}
                  <tr>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      Product
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      Upon Rising
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      With Breakfast
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      Mid Morning
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      With Lunch
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      Mid Afternoon
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      With Dinner
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      Before Bed
                    </th>
                    <th className="p-3 fw-normal text-dark fw-sbold">
                      Instructions / Notes
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {products && products.length > 0 ?
                    products.map((product) => {
                      return (
                        <tr>
                          <td className="p-3 border-0">
                            <b>
                              {decode(product.productName)}
                            </b>
                          </td>
                          <td className="p-3 border-0">{product.dosageUponRising}</td>
                          <td className="p-3 border-0">{product.dosageBreakfast}</td>
                          <td className="p-3 border-0">{product.dosageMidMorning}</td>
                          <td className="p-3 border-0">{product.dosageLunch}</td>
                          <td className="p-3 border-0">{product.dosageMidAfternoon}</td>
                          <td className="p-3 border-0">{product.dosageDinner}</td>
                          <td className="p-3 border-0">{product.dosageBeforeBed}</td>
                          <td className="p-3 border-0">
                            <b>
                              {product.instructions}
                            </b>
                            <p className="m-0 py-1">
                              Conditions/Deficiencies: {product.conditions.map(condition => condition)} *
                            </p>
                          </td>
                        </tr>
                      )
                    })
                    :
                    <tr>
                      <td colSpan={11} className="p-3 border-0">Data not available</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="py-2">
          <div
            className="Note px-3 py-2 commonCardBox d-flex align-items-start"
            style={{ background: "rgb(245, 245, 245)" }}
          >
            <div className="imgWrp me-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_0_5147)">
                  <path
                    d="M8.34343 0.15332C4.20184 0.15332 0.84375 3.51142 0.84375 7.653C0.84375 11.7946 4.20184 15.1533 8.34343 15.1533C12.485 15.1533 15.8437 11.7946 15.8437 7.653C15.8437 3.51142 12.485 0.15332 8.34343 0.15332ZM9.9047 11.7768C9.51867 11.9292 9.21137 12.0447 8.98089 12.1247C8.72237 12.2092 8.45154 12.2497 8.17962 12.2447C7.71232 12.2447 7.34851 12.1305 7.08946 11.9025C6.83042 11.6746 6.70153 11.3857 6.70153 11.0346C6.70153 10.8981 6.71105 10.7584 6.7301 10.6162C6.75364 10.4542 6.78479 10.2934 6.82343 10.1343L7.30661 8.4276C7.34915 8.26379 7.38597 8.10824 7.41518 7.96348C7.44438 7.81745 7.45835 7.68348 7.45835 7.56157C7.45835 7.34443 7.41327 7.19205 7.32375 7.10634C7.23296 7.02062 7.06216 6.97872 6.80756 6.97872C6.68311 6.97872 6.55486 6.99713 6.42343 7.03586C6.29327 7.07586 6.18026 7.11205 6.08756 7.1476L6.21518 6.62189C6.53137 6.493 6.83423 6.38253 7.12311 6.2911C7.38729 6.20271 7.66362 6.15602 7.94216 6.15268C8.40629 6.15268 8.76438 6.2657 9.01645 6.48919C9.26724 6.71332 9.39359 7.00475 9.39359 7.36284C9.39359 7.43713 9.3847 7.56792 9.36756 7.75459C9.35266 7.92902 9.32033 8.10152 9.27105 8.26951L8.79042 9.9711C8.74734 10.125 8.71195 10.281 8.68438 10.4384C8.65821 10.5694 8.64271 10.7023 8.63803 10.8359C8.63803 11.0619 8.68819 11.2162 8.78978 11.2981C8.8901 11.38 9.06597 11.4213 9.31486 11.4213C9.43232 11.4213 9.56375 11.4003 9.71232 11.3597C9.85962 11.319 9.96629 11.2828 10.0336 11.2517L9.9047 11.7768ZM9.81962 4.87014C9.60108 5.07623 9.31043 5.18839 9.0101 5.18253C8.69518 5.18253 8.42343 5.0784 8.1974 4.87014C8.08991 4.77559 8.00405 4.659 7.94565 4.52829C7.88725 4.39759 7.8577 4.25584 7.85899 4.11268C7.85899 3.81745 7.97327 3.56348 8.1974 3.35332C8.41641 3.14559 8.70829 3.03226 9.0101 3.03776C9.32565 3.03776 9.59613 3.14253 9.81962 3.35332C10.0437 3.56348 10.1561 3.81745 10.1561 4.11268C10.1561 4.40919 10.0437 4.66189 9.81962 4.87014Z"
                    fill="#030104"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_0_5147">
                    <rect
                      width="15"
                      height="15"
                      fill="white"
                      transform="translate(0.84375 0.15332)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="content">
              <p className="m-0 text-muted">
                <i>
                  *Statements made on this site and reference materials have not
                  been evaluated by the Food and Drug Administration. These
                  products or protocols may be helpful in correcting the
                  imbalances associated with the potential
                  conditions/deficiencies related to your client's symptoms.
                  These products or protocols are not intended to diagnose,
                  treat, cure or prevent any disease or be used as a substitute
                  for appropriate care of a qualified health practitioner.
                </i>
              </p>
            </div>
          </div>
        </div>
        <div className="py-2 mt-3 border-top">
          <div className="top d-flex align-items-center justify-content-between gap-10">
            <div className="left">
              <p className="capitalize text-dark fw-sbold m-0">
                Top Potential Supports
              </p>
              <p className="m-0 py-2">
                The below list of Potential Supports looks across your client's
                questions/answers from this NAQ and it shows the most frequently
                listed supports for those questions. Unlike the Recommendation
                report, this list is completely based off the individual
                questions and not the Potential Conditions/Deficiencies in the
                Symptom Burden Report.
              </p>
            </div>
          </div>
        </div>
        <div className="py-2">
          <Row>
            <Col lg="6" className="my-2 py-3">
              <p className="capitalize m-0 text-dark fw-bold">NUTRIENTS</p>
              <ul className=" mb-0" style={{ maxWidth: "300px" }}>
                <li className="">
                  Nutrients to support bile flow: beet juice, taurine, vitamin C
                  and pancrelipase{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Betaine HCL, pepsin, and pancreatin{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Nutrients that heal the intestines{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Herbs that cleanse the liver{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Micro emulsified oregano{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
              </ul>
            </Col>
            <Col lg="6" className="my-2 py-3">
              <p className="capitalize m-0 text-dark fw-bold">
                Supplements
              </p>
              <ul className=" mb-0" style={{ maxWidth: "300px" }}>
                <li className="">
                  Biotics Beta TCP
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Biotics Hydro-Zyme{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Biotics GI Resolve{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Biotics MCS-2{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Biotics ADP{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
              </ul>
            </Col>
            <Col lg="6" className="my-2 py-3">
              <p className="capitalize m-0 text-dark fw-bold">Foods</p>
              <ul className=" mb-0" style={{ maxWidth: "300px" }}>
                <li className="">
                  Beets
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Vitamin C-rich Foods (Citrus fruits, Peaches, Rose Hips,
                  Cherries, Peppers, Strawberries, Broccoli, Sardines, Organ
                  Meats){" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Whole Eggs{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Salmon{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Dark Green Leafy Vegetables{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
              </ul>
            </Col>
            <Col lg="6" className="my-2 py-3">
              <p className="capitalize m-0 text-dark fw-bold">Lifestyle</p>
              <ul className=" mb-0" style={{ maxWidth: "300px" }}>
                <li className="">
                  Support hydration and electrolyte balance (away from meals)
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Chew food well{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Support digestion{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Take a few deep breaths before eating{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
                <li className="">
                  Cook with fresh or dried oregano{" "}
                  <span className="icn ms-1">
                    <InfoIcn />
                  </span>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(RecommendationReport);